import {
  DISCOUNT_KEY,
  DISCOUNT_TYPE,
  OFFER_TYPE,
} from "../../../pages/promotions/constants";
import {
  MAX_PERCENT_DISCOUNT,
  PERCENT_DISCOUNT_LIMIT_MESSAGE,
} from "../OfferType/offerTypeConstants";

/**
 * True when a typed/stored percentage amount is above the 100% cap.
 *
 * Values arrive as strings from the number inputs and as numbers from a saved
 * promo, so both are coerced. Anything non-numeric (an empty field mid-edit)
 * is not "over the limit" — the callers handle emptiness themselves.
 */
export const exceedsPercentLimit = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) && numeric > MAX_PERCENT_DISCOUNT;
};

const percentKeys = DISCOUNT_KEY[OFFER_TYPE.PERCENT];

const discountVOExceedsPercentLimit = (discountVO) => {
  if (!discountVO || discountVO.mCompDiscountType !== OFFER_TYPE.PERCENT) {
    return false;
  }

  if (discountVO.discountType === DISCOUNT_TYPE.DAY_WISE) {
    return Object.values(discountVO[percentKeys.map] || {}).some(
      exceedsPercentLimit
    );
  }

  return exceedsPercentLimit(discountVO[percentKeys.amount]);
};

/**
 * Submit-time guard for the percentage cap, mirroring
 * validateTargetingConditions: returns an array of messages, empty when valid.
 *
 * Also the source of truth for the inline warning and the disabled footer, so
 * all three agree on what counts as over the cap. That includes values no
 * keystroke ever passed through — a promo saved before the cap existed and
 * reopened for edit/duplicate, or one seeded by another flow.
 *
 * The cap is deliberately independent of discountVO.priceAdjustment: an
 * INCREASE amount is held to 100% exactly as a DECREASE is.
 *
 * Stacked (GC-created) promos carry an array of discountVO entries, so both
 * shapes are checked.
 *
 * @param {Object} promo - The promo being submitted
 * @returns {string[]} Validation error messages
 */
export function validateDiscountAmounts(promo) {
  const discountVO = promo?.rateRule?.ruleVO?.discountVO;
  const entries = Array.isArray(discountVO) ? discountVO : [discountVO];

  return entries.some(discountVOExceedsPercentLimit)
    ? [PERCENT_DISCOUNT_LIMIT_MESSAGE]
    : [];
}
